import React from 'react';
import { Box, Link, Button } from '@chakra-ui/react';
import { StaticImage } from 'gatsby-plugin-image';
import Layout from '../../components/Layout';
import InfoSection from '../../components/shared/InfoSection';
import HeroWithBackgroundImage from '../../components/shared/HeroWithBackgroundImage';
import CustomerQuoteSection from '../../components/shared/CustomerQuoteSection';
import TryHoverTodaySection from '../../components/shared/TryHoverTodaySection';
import HeroImage from '../../images/home-owner-hero-1.webp';

const INFO_ITEMS = [
  {
    image: (
      <StaticImage
        src="../../images/icon-persona-homeowner-easily-visualize.svg"
        alt="Icon home"
      />
    ),
    title: 'Easily Visualize',
    description:
      'See what change really looks like. Create the perfect home with design features that let you view different manufacturers’ products and colors on the exterior of your home.',
  },
  {
    image: (
      <StaticImage
        src="../../images/icon-persona-homeowner-accurate-estimates.svg"
        alt="Icon phone"
      />
    ),
    title: 'Accurate Estimates',
    description:
      "Don’t sit around your house waiting. Ask a contractor or an insurance adjuster to provide you with an accurate estimate using HOVER's measurements.",
  },
  {
    image: (
      <StaticImage
        src="../../images/icon-persona-homeowner-eliminate-miscommunication.svg"
        alt="Icon people"
      />
    ),

    title: 'Eliminate any Miscommunication',
    description:
      'Be on the same page as your contractor or insurance provider. Show them exactly what you need and confirm the work that needs to get done.',
  },
];

const Homeowners = () => (
  <Layout
    title="Design App for Homeowners"
    description="Easily transform smartphone photos of your home into a scaled, customizable 3D model. See what change really looks like. Create the perfect home with design features that let you view different manufacturers’ products and colors on the exterior of your home with our design app for homeowners."
  >
    <HeroWithBackgroundImage
      imageUrl={HeroImage}
      title="Visualize every project and get an accurate estimate."
      description="Easily transform smartphone photos of your home into a scaled, customizable 3D model."
      buttonText="Start Free Now"
      ctaLink="/signup/"
    />
    <InfoSection
      sectionTitle="Why HOVER?"
      infoItems={INFO_ITEMS}
      numColumns={3}
    />
    <Box mx="auto" maxW="xs" textAlign="center">
      <Link href="/product/">
        <Button variant="outline" size="lg" width="100%">
          See how it works
        </Button>
      </Link>
    </Box>
    <CustomerQuoteSection
      image={
        <StaticImage
          style={{ borderRadius: '100%' }}
          src="../../images/hover-customer-profile-anna-f.jpeg"
          alt="Icon happy customer"
        />
      }
      quote="
      I love HOVER’s design features. It’s amazing to be able to see my home in 3D by just taking a few photos. I love discovering new colors and material and showing my contractor what I want my home to look like."
      authorDescription="Anna F."
    />
    <TryHoverTodaySection
      description="As a homeowner, use HOVER for free"
      buttonText="Start Free Now"
      ctaLink="/signup/"
    />
  </Layout>
);

export default Homeowners;
